import { CommonModule } from '@angular/common';
import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '@app/app-routing.module';
import { UsersService } from '@app/shared/services/users.service';
import { BaseComponent } from '@shared/base/components/base-component';

@Component({
    selector: 'intello-website-home',
    standalone: true,
    templateUrl: './home.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,

        MatIconModule,
    ]
})
export class HomeComponent extends BaseComponent {

    // -----------------------------------------------------------------------------------------------------
    // @ PRIVATE INSTANCE VARIABLES
    // -----------------------------------------------------------------------------------------------------

    user$ = rxResource({
        stream: () => this.usersService.getCurrentUser()
    })

    hasPremiumAccess = computed(() => {
        const user = this.user$.hasValue() ? this.user$.value() : undefined;

        if (user) {
            return user.hasPremiumAccess;
        }
    });

    // -----------------------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // -----------------------------------------------------------------------------------------------------

    constructor(
        private usersService: UsersService
    ) {
        super();
    }
}
